export const DocFlowSendingFieldName = {
  AdditionalEmail: 'additional_email',
  Building: 'building',
  Email: 'email',
  EpostPermissions: 'epost_permissions',
  File: 'file',
  Flat: 'flat',
  PagesCount: 'pages_count',
  PreferredCommunication: 'preferred_communication',
  Recipient: 'recipient',
  Role: 'role',
  SaveToProfile: 'save_to_profile',
  SendAdditionalEmail: 'send_additional_email',
  SendEmail: 'send_email',
  SendEpost: 'send_epost',
  Size: 'size',
  Status: 'status',
}

export const DocFlowSendingWidgetType = {
  CommunicationSettings: 'communication',
  EmailSettings: 'email',
  EpostSettings: 'epost',
  Result: 'results',
}

export const DocFlowSendingWidgetProcessFieldName = {
  CommunicationSettingsPhase: 'communication_settings_phase',
  CommunicationSettingsStatus: 'communication_settings_status',
  DeleteBlacklistUsers: 'delete_blacklist_users',
  EmailAccount: 'email_account',
  EmailBcc: 'email_bcc',
  EmailCc: 'email_cc',
  EmailCredentials: 'email_credentials',
  EmailDocumentTemplates: 'email_document_templates',
  EmailFiles: 'email_files',
  EmailFilesAsLinks: 'email_files_as_links',
  EmailPrinter: 'email_printer',
  EmailPrinterId: 'email_printer_id',
  EmailSettingsPhase: 'email_settings_phase',
  EmailSettingsStatus: 'email_settings_status',
  EmailSnippet: 'email_snippet',
  EmailSnippetDependencies: 'email_snippet_dependencies',
  EmailText: 'email_text',
  EmailTitle: 'email_title',
  EpostSettingsPhase: 'epost_settings_phase',
  EpostSettingsStatus: 'epost_settings_status',
  HasCommunicationSettingsPhaseError: 'has_communication_settings_phase_error',
  IsEmailDisabledForAll: 'is_email_disabled_for_all',
  IsEpostDisabledForAll: 'is_epost_disabled_for_all',
  ResultsPhase: 'results_phase',
  ResultsStatus: 'results_status',
  SettingsFrom: 'settings_from',
  SettingsTo: 'settings_to',
}

export const DocFlowSendingWidgetPhaseStatus = {
  Completed: 1,
  NotStarted: null,
  Skipped: 3,
  Started: 0,
  StartedWidthError: 2,
}

export const DocFlowSendingWidgetStatus = {
  Active: 0,
  NotActive: 1,
}

export const DocFlowSendingWidgetNotificationType = {
  Error: 'error',
  Success: 'success',
}

export const DocFlowSendingNextPhaseErrorType = {
  Common: 'Epost_common_error ',
  CostIsOutdated: 'Epost_cost_is_outdated_error',
  NotAvailableAccount: 'Not_available_account_or_credentials',
  NotCalculateWithoutDocuments:
    'You_can_not_calculate_it_without_epost_documents',
  NotEnoughCredits: 'Epost_not_enough_credits_limit_error',
  PagesCountLimit: 'Pages_count_limit_reached',
}

export const DOC_FLOW_SENDING_WIDGET_NEXT = {
  [DocFlowSendingWidgetType.CommunicationSettings]:
    DocFlowSendingWidgetType.EpostSettings,
  [DocFlowSendingWidgetType.EmailSettings]: DocFlowSendingWidgetType.Result,
  [DocFlowSendingWidgetType.EpostSettings]:
    DocFlowSendingWidgetType.EmailSettings,
}

export const DOC_FLOW_SENDING_WIDGET_PREVIOUS = {
  [DocFlowSendingWidgetType.EmailSettings]:
    DocFlowSendingWidgetType.EpostSettings,
  [DocFlowSendingWidgetType.EpostSettings]:
    DocFlowSendingWidgetType.CommunicationSettings,
  [DocFlowSendingWidgetType.Result]: DocFlowSendingWidgetType.EmailSettings,
}

export const DOC_FLOW_SENDING_TABLE_FILTER_STATE_URL = `/idwell-api/api/v3/table/filter-states/document-stapling-sendings/all/`

export const DOC_FLOW_SENDING_TABLE_CONFIG_URL = `/idwell-api/api/v3/table/tables/document-stapling-sendings/`

export const DOC_FLOW_SENDING_HEADER_PROPS = {
  nextButtonProps: {
    text: 'DocumentStapling.SendingFinishBtnKey',
    tooltip: 'DocumentStapling.SendingFinishBtnDisabledTooltipKey',
  },
}

export const DOC_FLOW_SENDING_NEXT_PHASE_SERVER_ERRORS = {
  [DocFlowSendingNextPhaseErrorType.Common]:
    'DocFlow.SendingNextPhaseErrorEpostCommonTextKey',
  [DocFlowSendingNextPhaseErrorType.CostIsOutdated]:
    'DocFlow.SendingNextPhaseErrorEpostCostIsOutdatedTextKey',
  [DocFlowSendingNextPhaseErrorType.NotAvailableAccount]:
    'DocFlow.SendingNextPhaseErrorNotAvailableAccountTextKey',
  [DocFlowSendingNextPhaseErrorType.NotCalculateWithoutDocuments]:
    'DocFlow.SendingNextPhaseCanNotCalculateWithoutEpostDocumentsTextKey',
  [DocFlowSendingNextPhaseErrorType.NotEnoughCredits]:
    'DocFlow.SendingNextPhaseErrorEpostNotEnoughCreditsTextKey',
  [DocFlowSendingNextPhaseErrorType.PagesCountLimit]:
    'DocFlow.SendingNextPhaseErrorPagesCountLimitTextKey',
}
